import { render, staticRenderFns } from "./OrganismTicketCreateNewTicket.vue?vue&type=template&id=1e63b1b4&scoped=true&"
import script from "./OrganismTicketCreateNewTicket.vue?vue&type=script&lang=js&"
export * from "./OrganismTicketCreateNewTicket.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTicketCreateNewTicket.vue?vue&type=style&index=0&id=1e63b1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e63b1b4",
  null
  
)

export default component.exports